export default __webpack_public_path__ + "static/media/infobutton.7320bef7.svg";